"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    Globalize.addCultureInfo("en", {
        messages: {
            TaskGuides_ControlLevel_ErrorMsg1: "You are not on the right page, the page appears to have been closed.",
            TaskGuides_ControlLevel_ErrorMsg2: "Close this dialog to continue with this task guide.",
            TaskGuides_ControlLevel_ErrorMsg3: "Close this page to continue with this task guide.",
            TaskGuides_ControlLevel_ErrorTitle1: "Oops!",
            TaskGuidesStep_RailsSwitchAckNote: "You can lock or unlock access to all controls using this switch at any step during task guide.",
            TaskGuidesStep_ShowLess: "Show less",
            TaskGuidesStep_ShowMore: "Show more",
        }
    });
    var ax;
    (function (ax) {
        var taskRecorder;
        (function (taskRecorder) {
            var ControlLevelErrors;
            (function (ControlLevelErrors) {
                ControlLevelErrors[ControlLevelErrors["NoError"] = 0] = "NoError";
                ControlLevelErrors[ControlLevelErrors["FormNotFound"] = 1] = "FormNotFound";
                ControlLevelErrors[ControlLevelErrors["FormCoveredByDialog"] = 2] = "FormCoveredByDialog";
                ControlLevelErrors[ControlLevelErrors["FormCoveredByAnotherForm"] = 3] = "FormCoveredByAnotherForm";
            })(ControlLevelErrors = taskRecorder.ControlLevelErrors || (taskRecorder.ControlLevelErrors = {}));
        })(taskRecorder = ax.taskRecorder || (ax.taskRecorder = {}));
        var taskGuide;
        (function (taskGuide) {
            /** Used in the task guide chain to produce a guided step object with the information needed for Task Guide tooltip visualization. */
            var ControlComponent = /** @class */ (function () {
                function ControlComponent(controller) {
                    var _this = this;
                    this.dispose = function () {
                        var e_1, _a;
                        try {
                            for (var _b = __values(_this.subscriptions), _c = _b.next(); !_c.done; _c = _b.next()) {
                                var subscription = _c.value;
                                if (subscription && subscription.dispose) {
                                    subscription.dispose();
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        _this.subscriptions = null;
                        $dyn.ax.taskGuide.repositionGuidedQtip = null;
                    };
                    this.subscriptions = [];
                    this.guidedStep = null;
                    this.inputChanged = false;
                    this._currentErrorState = taskRecorder.ControlLevelErrors.NoError;
                    if (!taskGuide.repositionGuidedQtip) {
                        taskGuide.repositionGuidedQtip = $dyn.observable(false);
                    }
                    $dyn.observe($dyn.ax.taskGuide.repositionGuidedQtip, function (reposition) {
                        if (reposition && _this.guidedStep) {
                            _this.guidedStepHandler();
                        }
                    });
                    this.subscriptions.push($dyn.observe($dyn.clientBusy, function (isBusy) {
                        if (!isBusy && _this.guidedStep) {
                            _this.guidedStepHandler();
                        }
                    }));
                }
                ControlComponent.prototype.setup = function (input, output) {
                    var _this = this;
                    this.input = input;
                    this.output = output;
                    this.subscriptions.push($dyn.observe(input, function (guidedStep) {
                        _this.guidedStep = guidedStep;
                        _this.inputChanged = true;
                        _this.guidedStepHandler();
                    }));
                };
                ControlComponent.prototype.guidedStepHandler = function () {
                    var _this = this;
                    if ($dyn.value($dyn.clientBusy)) {
                        return;
                    }
                    var guidedStep = this.guidedStep;
                    var inputChanged = this.inputChanged;
                    this.inputChanged = false;
                    var previousErrorState = this._currentErrorState;
                    if ($dyn.serverForm.defaultChannel && $dyn.serverForm.interactionHandler) {
                        var interactionChannel = $dyn.serverForm.defaultChannel();
                        var interactionHandler = $dyn.serverForm.interactionHandler; // only looking into the local window
                        if (guidedStep) {
                            var guidedStepOptions = {
                                action: guidedStep.action,
                                arguments: guidedStep.arguments,
                            };
                            var guidedStepContentModel = {
                                allowBack: guidedStep.allowBack,
                                allowNext: guidedStep.allowNext,
                                Example: "",
                                Note: guidedStep.note,
                                Step: guidedStep.step,
                                Title: guidedStep.title
                            };
                            var formElement = void 0;
                            // Highlight a control if it has control and form defined on them
                            if (guidedStep.controlName && guidedStep.formId) {
                                formElement = interactionHandler.getFormElement(guidedStep.formId + "_" + interactionChannel.channel.channelId);
                                if (formElement) {
                                    var controlParams = $dyn.serverForm.getControlParams(guidedStep.controlName, formElement.dynOptions);
                                    if (controlParams) {
                                        var control = $dyn.context(controlParams._element);
                                        if (control) {
                                            guidedStepOptions = control.getTaskGuideParams(guidedStepOptions);
                                        }
                                    }
                                }
                            }
                            else if (guidedStep.formId) {
                                // Otherwise highlight the form if we have a form ID
                                formElement = interactionHandler.getFormElement(guidedStep.formId + "_" + interactionChannel.channel.channelId);
                                if (formElement) {
                                    var form = $dyn.context(formElement);
                                    if (form) {
                                        guidedStepOptions = form.getTaskGuideParams(guidedStepOptions);
                                    }
                                }
                            }
                            var activeElement = $dyn.shell.getActiveForm();
                            var activeElementContext = void 0;
                            if (activeElement) {
                                activeElementContext = $dyn.context(activeElement);
                            }
                            // evaluate error state based on formElement
                            if (guidedStep.formId && !formElement) {
                                this._currentErrorState = $dyn.ax.taskRecorder.ControlLevelErrors.FormNotFound;
                            }
                            else if (formElement) {
                                var formElementContext = $dyn.context(formElement);
                                if ((formElement === activeElement) ||
                                    (activeElementContext instanceof $dyn.controls.Popup) ||
                                    (activeElementContext instanceof $dyn.controls.PartForm)) {
                                    // all good, proceed with step recieved from server
                                    this._currentErrorState = $dyn.ax.taskRecorder.ControlLevelErrors.NoError;
                                }
                                else if (formElementContext instanceof $dyn.controls.PartForm && (activeElement && $.contains(activeElement, formElement))) {
                                    this._currentErrorState = $dyn.ax.taskRecorder.ControlLevelErrors.NoError;
                                }
                                else if (activeElementContext instanceof $dyn.controls.Dialog) {
                                    this._currentErrorState = $dyn.ax.taskRecorder.ControlLevelErrors.FormCoveredByDialog;
                                }
                                else if (activeElementContext instanceof $dyn.controls.Form) {
                                    this._currentErrorState = $dyn.ax.taskRecorder.ControlLevelErrors.FormCoveredByAnotherForm;
                                }
                            }
                            else { // only if there is a case we didn't explicitly specify
                                this._currentErrorState = $dyn.ax.taskRecorder.ControlLevelErrors.NoError;
                            }
                            // only generate output if input changed or errorState changed
                            if (inputChanged || (this._currentErrorState !== previousErrorState) || $dyn.value($dyn.ax.taskGuide.repositionGuidedQtip)) {
                                $dyn.ax.taskGuide.repositionGuidedQtip(false);
                                var clonedGuidedStepOptions_1 = $.extend({}, guidedStepOptions);
                                var clonedGuidedStepContentModel_1 = $.extend({}, guidedStepContentModel);
                                if (this._currentErrorState === $dyn.ax.taskRecorder.ControlLevelErrors.FormNotFound) {
                                    $.extend(clonedGuidedStepContentModel_1, {
                                        Note: "",
                                        Step: $dyn.label("TaskGuides_ControlLevel_ErrorMsg1"),
                                        Title: $dyn.label("TaskGuides_ControlLevel_ErrorTitle1"),
                                    });
                                    clonedGuidedStepOptions_1.target = null;
                                    clonedGuidedStepOptions_1.avoidRailsModeBlocks = true;
                                }
                                else if (this._currentErrorState === $dyn.ax.taskRecorder.ControlLevelErrors.FormCoveredByDialog) {
                                    // Ask to close the dialog
                                    $.extend(clonedGuidedStepContentModel_1, {
                                        Note: "",
                                        Step: $dyn.label("TaskGuides_ControlLevel_ErrorMsg2"),
                                        Title: "",
                                    });
                                    if (activeElementContext) {
                                        clonedGuidedStepOptions_1 = activeElementContext.getTaskGuideParams($.extend(clonedGuidedStepOptions_1, { action: "" }));
                                    }
                                    clonedGuidedStepOptions_1.avoidRailsModeBlocks = true;
                                }
                                else if (this._currentErrorState === $dyn.ax.taskRecorder.ControlLevelErrors.FormCoveredByAnotherForm) {
                                    // Ask to close the form
                                    $.extend(clonedGuidedStepContentModel_1, {
                                        Note: "",
                                        Step: $dyn.label("TaskGuides_ControlLevel_ErrorMsg3"),
                                        Title: "",
                                    });
                                    if (activeElementContext) {
                                        clonedGuidedStepOptions_1 = activeElementContext.getTaskGuideParams($.extend(clonedGuidedStepOptions_1, { action: "RequestClose" }));
                                    }
                                    clonedGuidedStepOptions_1.avoidRailsModeBlocks = true;
                                }
                                if (this._currentErrorState !== $dyn.ax.taskRecorder.ControlLevelErrors.NoError &&
                                    $dyn.ax.taskRecording && $dyn.ax.taskRecording.taskRecorderStateControl &&
                                    $dyn.ax.taskRecording.taskRecorderStateControl.LogTaskGuideClientErrorTelemetryEvent) {
                                    // Log telemetry event with error type.
                                    $dyn.callFunction($dyn.ax.taskRecording.taskRecorderStateControl.LogTaskGuideClientErrorTelemetryEvent, this, [this._currentErrorState]);
                                }
                                // If target is an observable, subscribe to it and add any necessary subscriptions
                                if ($dyn.isObservable(clonedGuidedStepOptions_1.target)) {
                                    if (clonedGuidedStepOptions_1.targetSubscriptions) {
                                        this.subscriptions.concat(clonedGuidedStepOptions_1.targetSubscriptions);
                                    }
                                    this.subscriptions.push($dyn.observe(clonedGuidedStepOptions_1.target, function (newTarget) {
                                        clonedGuidedStepOptions_1.target = newTarget;
                                        _this.output({ content: clonedGuidedStepContentModel_1, options: clonedGuidedStepOptions_1 });
                                    }));
                                }
                                else {
                                    this.output({ content: clonedGuidedStepContentModel_1, options: clonedGuidedStepOptions_1 });
                                }
                            }
                        }
                    }
                };
                return ControlComponent;
            }());
            taskGuide.ControlComponent = ControlComponent;
        })(taskGuide = ax.taskGuide || (ax.taskGuide = {}));
    })(ax = $dyn.ax || ($dyn.ax = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ControlComponent.js.map
